export default {
	CURRENCY: 'XPF'
};

function sortByAlphabet(data, name) {
	data.sort(function(a, b) {
		if (a[name] < b[name]) {
			return -1;
		}
		if (a[name] > b[name]) {
			return 1;
		}
		return 0;
	});
	return data;
}

function removeDuplicateArrayObject(arr) {
    return arr.reduce((unique, o) => {
        if (!unique.some(obj => obj.label === o.label && obj.value === o.value)) {
            unique.push(o);
        }
        return unique;
    }, []);
}

export { sortByAlphabet, removeDuplicateArrayObject };
